import Select from "react-select";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import Account_Created_Modal from "../account-created-modal/Account_Created_Modal";
import Common_Login_Button from "../../../common_components/common-login-button/Common_Login_Button";
import "react-phone-input-2/lib/style.css";
import "./Expert_Login.css";
import { useContext, useEffect, useRef, useState } from "react";
import {
  AllState,
  AllDistrict,
  AllProfession,
  AllSubProfession,
} from "../../../../features/admin/common/Slice";
import {
  verifyOtp,
  CreateExpert1Signup,
  CreateExpert2Signup,
  sendMobileOtp,
  sendLoginOtp,
  LoginverifyOtp,
  GETExpert,
  addharVerifyOtp,
  addharSendOtp,
} from "../../../../features/admin/auth/Slice";
import { IDS } from "../../../../utils/IDS";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { Context } from "../../../../utils/context";
import Cookies from "js-cookie";

const Expert_Login = ({ activeTab }) => {
  const dispatch = useDispatch();
  const userType = IDS.USER_TYPES[activeTab?.toUpperCase()];
  const { setSignin, isTokenValid, deviceKey } = useContext(Context);

  const states = useSelector((state) => state?.common?.all_state);
  const districts = useSelector((state) => state?.common?.all_district);
  const professions = useSelector((state) => state?.common?.all_profession);
  const all_sub_profession = useSelector(
    (state) => state?.common?.all_sub_professions,
  );

  useEffect(() => {
    dispatch(AllState());
    dispatch(AllDistrict());
    dispatch(AllProfession());
  }, [dispatch]);

  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { lat: "", long: "" },
  });

  const mapRef = useRef();
  const mapInstance = useRef(null);
  const markerRef = useRef(null);
  const searchInputRef = useRef();

  const selectedState = watch("state_id");
  const profilePicFile = watch("profile_pic");
  const loginMobile = watch("login_mobile");
  const registerMobile = watch("mobile_number");
  const selectedProfession = watch("profession_id");

  const navigate = useNavigate();

  // ====================== Common States ======================
  const [isRegistering, setIsRegistering] = useState(false);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [modalText, setModalText] = useState("");

  // ====================== Login OTP States ======================
  const [isOtpSentLogin, setIsOtpSentLogin] = useState(false);
  const [isOtpVerifiedLogin, setIsOtpVerifiedLogin] = useState(false);
  const [loginOtp, setLoginOtp] = useState(["", "", "", "", "", ""]);
  const [loginOtpError, setLoginOtpError] = useState("");
  const [mobileOtpErrorLogin, setMobileOtpErrorLogin] = useState("");
  const [timerLogin, setTimerLogin] = useState(60);
  const [isMobileLockedLogin, setIsMobileLockedLogin] = useState(false);
  const [isOtpExpiredLogin, setIsOtpExpiredLogin] = useState(false);

  // ====================== Registration OTP States ======================
  const [isOtpSentRegister, setIsOtpSentRegister] = useState(false);
  const [isOtpVerifiedRegister, setIsOtpVerifiedRegister] = useState(false);
  const [registerOtp, setRegisterOtp] = useState(["", "", "", "", "", ""]);
  const [registerOtpError, setRegisterOtpError] = useState("");
  const [mobileOtpErrorRegister, setMobileOtpErrorRegister] = useState("");
  const [timerRegister, setTimerRegister] = useState(60);
  const [isMobileLockedRegister, setIsMobileLockedRegister] = useState(false);
  const [isOtpExpiredRegister, setIsOtpExpiredRegister] = useState(false);
  const [loadingSendLoginOtp, setLoadingSendLoginOtp] = useState(false);
  const [loadingVerifyLoginOtp, setLoadingVerifyLoginOtp] = useState(false);
  const [loadingSendRegisterOtp, setLoadingSendRegisterOtp] = useState(false);
  const [loadingVerifyRegisterOtp, setLoadingVerifyRegisterOtp] = useState(
    false,
  );
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [isAadharOtpSent, setIsAadharOtpSent] = useState(false);
  const [isAadharOtpVerified, setIsAadharOtpVerified] = useState(false);
  const [aadharOtp, setAadharOtp] = useState(["", "", "", "", "", ""]);
  const [aadharOtpError, setAadharOtpError] = useState("");
  const [aadharOtpTimer, setAadharOtpTimer] = useState(600); // 10 minutes
  const [isAadharOtpExpired, setIsAadharOtpExpired] = useState(false);
  const [loadingAadharSendOtp, setLoadingAadharSendOtp] = useState(false);
  const [loadingAadharVerifyOtp, setLoadingAadharVerifyOtp] = useState(false);
  const [isAadharLocked, setIsAadharLocked] = useState(false);

  const selectStyles = {
    control: (base) => ({
      ...base,
      height: "45px",
      borderRadius: "30px",
      border: "1px solid #ddd",
      boxShadow: "none",
      "&:hover": { border: "1px solid #aaa" },
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({ ...base, padding: "0 20px" }),
  };

  const catSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "45px",
      borderRadius: "30px",
      paddingTop: "15px",
      border: "1px solid #ddd",
      boxShadow: "none",
      "&:hover": { border: "1px solid #aaa" },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 99999 }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({ ...base, padding: "0 20px" }),
  };

  // ====================== OTP Handlers ======================
  const handleOtpChange = (value, index, isLogin) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = isLogin ? [...loginOtp] : [...registerOtp];
    newOtp[index] = value;
    if (isLogin) setLoginOtp(newOtp);
    else setRegisterOtp(newOtp);

    if (value && index < 5) {
      const nextId = `otp-${isLogin ? "login" : "register"}-${index + 1}`;
      document.getElementById(nextId)?.focus();
    }
  };

  const handleOtpKeyDown = (e, index, isLogin) => {
    if (e.key === "Backspace") {
      const newOtp = isLogin ? [...loginOtp] : [...registerOtp];
      if (newOtp[index]) {
        newOtp[index] = "";
      } else if (index > 0) {
        newOtp[index - 1] = "";
        const prevId = `otp-${isLogin ? "login" : "register"}-${index - 1}`;
        document.getElementById(prevId)?.focus();
      }
      if (isLogin) setLoginOtp(newOtp);
      else setRegisterOtp(newOtp);
    }
  };

  // ====================== Login OTP Functions ======================
  const handleSendLoginOtp = async () => {
    if (loadingSendLoginOtp) return;

    setLoadingSendLoginOtp(true);
    setMobileOtpErrorLogin("");
    try {
      const res = await dispatch(
        sendLoginOtp({
          mobile_number: getValues("login_mobile"),
          type: userType,
        }),
      ).unwrap();

      if (res?.success) {
        setIsOtpSentLogin(true);
        setIsOtpVerifiedLogin(false);
        setLoginOtp(["", "", "", "", "", ""]);
        setTimerLogin(60);
        setIsOtpExpiredLogin(false);
        setIsMobileLockedLogin(true);
      } else {
        setMobileOtpErrorLogin(res?.message || "Failed to send OTP");
      }
    } catch (err) {
      setMobileOtpErrorLogin(err?.message || "Something went wrong");
    } finally {
      setLoadingSendLoginOtp(false);
    }
  };

  const handleLoginVerifyOtp = async () => {
    const enteredOtp = loginOtp.join("");
    if (enteredOtp.length !== 6) {
      setLoginOtpError("Please enter 6 digit OTP");
      return;
    }

    if (loadingVerifyLoginOtp) return;
    setLoadingVerifyLoginOtp(true);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const long = position.coords.longitude;

          try {
            const res = await dispatch(
              LoginverifyOtp({
                mobile_number: getValues("login_mobile"),
                otp: enteredOtp,
                type: userType,
                device_key: deviceKey || "",
                lat: lat, // ✅ added
                long: long, // ✅ added
              }),
            ).unwrap();

            if (res?.success) {
              setIsOtpVerifiedLogin(true);
              setLoginOtpError("");
            } else {
              setLoginOtpError(res?.message || "Invalid OTP");
            }
          } catch (err) {
            setLoginOtpError(err?.message || "Invalid OTP");
          } finally {
            setLoadingVerifyLoginOtp(false);
          }
        },
        async (error) => {
          console.log("Location error:", error);

          // fallback if user denies location
          try {
            const res = await dispatch(
              LoginverifyOtp({
                mobile_number: getValues("login_mobile"),
                otp: enteredOtp,
                type: userType,
                device_key: deviceKey || "",
                lat: null,
                long: null,
              }),
            ).unwrap();

            if (res?.success) {
              setIsOtpVerifiedLogin(true);
              setLoginOtpError("");
            } else {
              setLoginOtpError(res?.message || "Invalid OTP");
            }
          } catch (err) {
            setLoginOtpError(err?.message || "Invalid OTP");
          } finally {
            setLoadingVerifyLoginOtp(false); // ✅ ADD THIS
          }
        },
      );
    } else {
      setLoginOtpError("Geolocation is not supported");
    }
  };

  // ====================== Register OTP Functions ======================
  const handleSendRegisterOtp = async () => {
    if (loadingSendRegisterOtp) return;

    setLoadingSendRegisterOtp(true);
    setMobileOtpErrorRegister("");
    try {
      const res = await dispatch(
        sendMobileOtp({
          mobile_number: getValues("mobile_number"),
          type: userType,
        }),
      );

      if (res?.meta?.requestStatus === "fulfilled") {
        setIsOtpSentRegister(true);
        setIsOtpVerifiedRegister(false);
        setRegisterOtp(["", "", "", "", "", ""]);
        setTimerRegister(60);
        setIsOtpExpiredRegister(false);
        setIsMobileLockedRegister(true);
      } else {
        setMobileOtpErrorRegister(
          res?.payload?.message || "Something went wrong",
        );
      }
    } catch (err) {
      setMobileOtpErrorRegister("Something went wrong");
    } finally {
      setLoadingSendRegisterOtp(false);
    }
  };

  const handleVerifyRegisterOtp = async () => {
    const enteredOtp = registerOtp.join("");
    if (enteredOtp.length !== 6) {
      setRegisterOtpError("Please enter 6 digit OTP");
      return;
    }

    if (loadingVerifyRegisterOtp) return;
    setLoadingVerifyRegisterOtp(true);

    // const res = await dispatch(
    //   verifyOtp({
    //     mobile_number: getValues("mobile_number"),
    //     otp: enteredOtp,
    //     type: userType,
    //   }),
    // );

    // if (res?.meta?.requestStatus === "fulfilled" && res?.payload?.success) {
    //   setIsOtpVerifiedRegister(true);
    //   setRegisterOtpError("");
    // } else {
    //   setRegisterOtpError(res?.payload?.message || "Invalid OTP");
    // }
    try {
      const res = await dispatch(
        verifyOtp({
          mobile_number: getValues("mobile_number"),
          otp: enteredOtp,
          type: userType,
        }),
      );

      if (res?.meta?.requestStatus === "fulfilled" && res?.payload?.success) {
        setIsOtpVerifiedRegister(true);
        setRegisterOtpError("");
      } else {
        setRegisterOtpError(res?.payload?.message || "Invalid OTP");
      }
    } finally {
      setLoadingVerifyRegisterOtp(false);
    }
  };

  // const handleSendAadharOtp = async () => {
  //   const aadharNo = getValues("adhar_no");

  //   if (!aadharNo || aadharNo.length !== 12) {
  //     setAadharOtpError("Enter valid 12 digit Aadhaar Number");
  //     return;
  //   }

  //   setLoadingAadharSendOtp(true);
  //   setAadharOtpError("");

  //   try {
  //     const res = await dispatch(
  //       addharSendOtp({
  //         aadhaar_number: aadharNo,
  //       }),
  //     );
  //     if (res?.payload?.success) {
  //       const newReqId = res?.payload?.data?.response?.ref_id;

  //       if (newReqId) {
  //         Cookies.set("aadhaar_ref_id", newReqId, { expires: 1 });
  //         console.log("New Req ID:", newReqId);
  //       }

  //       setIsAadharOtpSent(true);
  //       setIsAadharOtpVerified(false);
  //       setAadharOtp(["", "", "", "", "", ""]);
  //       setAadharOtpTimer(120);
  //       setIsAadharOtpExpired(false);
  //       setIsAadharLocked(true);
  //     } else {
  //       let errorMessage = "Failed to send Aadhaar OTP";

  //       if (typeof res?.payload?.message === "string") {
  //         errorMessage = res.payload.message;
  //       } else if (
  //         typeof res?.payload?.message === "object" &&
  //         res?.payload?.message?.aadhaar_number?.length
  //       ) {
  //         errorMessage = res.payload.message.aadhaar_number[0];
  //       } else if (res?.payload?.data?.msg) {
  //         errorMessage = res.payload.data.msg;
  //       }

  //       setAadharOtpError(errorMessage);
  //     }
  //   } catch (error) {
  //     setAadharOtpError("Something went wrong");
  //   } finally {
  //     setLoadingAadharSendOtp(false);
  //   }
  // };

  //below code was after client changes for showing the please try after some time showing error  and above code was showing all the error when success false
  const handleSendAadharOtp = async () => {
    const aadharNo = getValues("adhar_no");

    if (!aadharNo || aadharNo.length !== 12) {
      setAadharOtpError("Enter valid 12 digit Aadhaar Number");
      return;
    }

    setLoadingAadharSendOtp(true);
    setAadharOtpError("");

    try {
      const res = await dispatch(
        addharSendOtp({
          aadhaar_number: aadharNo,
        }),
      );

      if (res?.payload?.success) {
        const newReqId = res?.payload?.data?.response?.ref_id;

        if (newReqId) {
          Cookies.set("aadhaar_ref_id", newReqId, { expires: 1 });
        }

        setIsAadharOtpSent(true);
        setIsAadharOtpVerified(false);
        setAadharOtp(["", "", "", "", "", ""]);
        setAadharOtpTimer(600); // 10 minutes
        setIsAadharOtpExpired(false);
        setIsAadharLocked(true);
      } else {
        setAadharOtpError("Please try after sometime");
      }
    } catch (error) {
      setAadharOtpError("Please try after sometime");
    } finally {
      setLoadingAadharSendOtp(false);
    }
  };

  const handleVerifyAadharOtp = async () => {
    const enteredOtp = aadharOtp.join("");

    if (enteredOtp.length !== 6) {
      setAadharOtpError("Please enter 6 digit OTP");
      return;
    }

    const refId = Cookies.get("aadhaar_ref_id");

    setLoadingAadharVerifyOtp(true);

    try {
      const res = await dispatch(
        addharVerifyOtp({
          aadhaar_number: getValues("adhar_no"),
          otp: enteredOtp,
          req_id: refId,
        }),
      );

      if (res?.payload?.success) {
        setIsAadharOtpVerified(true);
        setAadharOtpError("");

        Cookies.remove("aadhaar_ref_id");
      } else {
        let errorMessage = "Invalid OTP";

        if (typeof res?.payload?.message === "string") {
          errorMessage = res.payload.message;
        } else if (typeof res?.payload?.message === "object") {
          const messageObj = res.payload.message;

          if (messageObj.req_id?.length) {
            errorMessage = messageObj.req_id[0];
          } else if (messageObj.otp?.length) {
            errorMessage = messageObj.otp[0];
          } else if (messageObj.aadhaar_number?.length) {
            errorMessage = messageObj.aadhaar_number[0];
          } else {
            errorMessage = Object.values(messageObj).flat()[0];
          }
        } else if (typeof res?.payload?.data === "string") {
          errorMessage = res.payload.data;
        }

        setAadharOtpError(errorMessage);
      }
    } catch (error) {
      setAadharOtpError(
        error?.response?.data?.message || "Something went wrong",
      );
    } finally {
      setLoadingAadharVerifyOtp(false);
    }
  };

  useEffect(() => {
    let interval;

    if (isAadharOtpSent && !isAadharOtpVerified && aadharOtpTimer > 0) {
      interval = setInterval(() => {
        setAadharOtpTimer((prev) => prev - 1);
      }, 1000);
    }

    if (aadharOtpTimer === 0 && isAadharOtpSent && !isAadharOtpVerified) {
      setIsAadharOtpExpired(true);
    }

    return () => clearInterval(interval);
  }, [isAadharOtpSent, isAadharOtpVerified, aadharOtpTimer]);

  const handleAadharOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...aadharOtp];
    newOtp[index] = value;

    setAadharOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-aadhar-${index + 1}`)?.focus();
    }
  };

  const handleAadharOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !aadharOtp[index] && index > 0) {
      document.getElementById(`otp-aadhar-${index - 1}`)?.focus();
    }
  };

  useEffect(() => {
    if (selectedProfession?.length > 0) {
      dispatch(
        AllSubProfession({
          profession_id: selectedProfession.map((item) => item.value),
        }),
      );

      setValue("sub_profession_id", []);
    }
  }, [selectedProfession, dispatch, setValue]);

  // ====================== Main Submit ======================
  const onSubmit = async (data) => {
    if (loadingSubmit) return;
    setLoadingSubmit(true);
    try {
      if (!isRegistering) {
        // LOGIN FLOW - Only on Login button click
        if (!isOtpVerifiedLogin) {
          alert("Please verify OTP first");
          // setLoadingSubmit(false);
          return;
        }
        try {
          setSignin(true);
          await isTokenValid();
          dispatch(GETExpert());
          navigate("/expert-login-details");
        } catch (err) {
          console.error("Login failed", err);
        }

        return;
      }

      // REGISTRATION FLOW
      if (!isOtpVerifiedRegister) {
        alert("Please verify OTP before registering");
        return;
      }

      if (!isAadharOtpVerified) {
        setAadharOtpError("Please verify Aadhaar OTP first");
        return;
      }

      try {
        const step1FormData = new FormData();
        step1FormData.append("name", data.name);
        step1FormData.append("mobile_number", data.mobile_number);
        step1FormData.append("whatsapp_no", "");
        step1FormData.append("adhar_no", data.adhar_no);
        step1FormData.append("state_id", data.state_id?.value);
        step1FormData.append("district_id", data.district_id?.value);
        step1FormData.append("type", userType);
        step1FormData.append("lat", data.lat);
        step1FormData.append("long", data.long);

        if (data.profile_pic?.[0]) {
          step1FormData.append("profile_pic", data.profile_pic[0]);
        }
        step1FormData.append("device_key", deviceKey || "");

        const step1Res = await dispatch(
          CreateExpert1Signup(step1FormData),
        ).unwrap();
        const expertId = step1Res?.data?.id || step1Res?.data?.user?.id;

        if (!expertId) throw new Error("No expert ID received");

        const professionIds =
          data.profession_id?.map((item) => item.value) || [];

        const subProfessionIds =
          data.sub_profession_id?.map((item) => item.value) || [];
        await dispatch(
          CreateExpert2Signup({
            id: expertId,
            dob: data.dob,
            experience: data.experience,
            profession: professionIds,
            sub_profession_id: subProfessionIds,
          }),
        ).unwrap();

        setModalText("Account Created Successfully!");
        setShowAccountModal(true);

        setTimeout(() => {
          setShowAccountModal(false);
          setIsRegistering(false);
          reset();
          setRegisterOtp(["", "", "", "", "", ""]);
          setIsOtpSentRegister(false);
          setIsOtpVerifiedRegister(false);
          setIsMobileLockedRegister(false);
          setIsOtpExpiredRegister(false);
        }, 2000);
      } catch (err) {
        console.error("Registration failed:", err);
        alert("Registration failed. Please try again.");
      }
    } catch (err) {
      console.error("Submit error:", err);
    } finally {
      setLoadingSubmit(false); // ✅ SINGLE PLACE
    }
  };

  // ====================== Map Logic ======================
  useEffect(() => {
    if (isRegistering) {
      loadMap();
    }

    return () => {
      // 🧹 CLEANUP OLD MAP
      if (markerRef.current) {
        markerRef.current.setMap(null);
        markerRef.current = null;
      }

      if (mapInstance.current) {
        mapInstance.current = null;
      }
    };
  }, [isRegistering]);

  // const loadMap = () => {
  //   if (window.google?.maps) {
  //     initMap();
  //     setTimeout(initAutocomplete, 500);
  //   } else {
  //     const interval = setInterval(() => {
  //       if (window.google?.maps) {
  //         clearInterval(interval);
  //         initMap();
  //         setTimeout(initAutocomplete, 500);
  //       }
  //     }, 100);
  //   }
  // };

  const loadMap = () => {
    // ❌ STOP if already initialized
    if (mapInstance.current) return;

    if (window.google?.maps) {
      initMap();
      setTimeout(initAutocomplete, 500);
    } else {
      const interval = setInterval(() => {
        if (window.google?.maps) {
          clearInterval(interval);
          initMap();
          setTimeout(initAutocomplete, 500);
        }
      }, 100);
    }
  };

  const loadMapWithPosition = (position) => {
    mapInstance.current = new window.google.maps.Map(mapRef.current, {
      center: position,
      zoom: 15,
    });
    markerRef.current = new window.google.maps.Marker({
      position,
      map: mapInstance.current,
      draggable: true,
    });

    setValue("lat", position.lat.toString());
    setValue("long", position.lng.toString());

    mapInstance.current.addListener("click", (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      setValue("lat", lat.toString());
      setValue("long", lng.toString());
      markerRef.current.setPosition({ lat, lng });
    });

    markerRef.current.addListener("dragend", (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      setValue("lat", lat.toString());
      setValue("long", lng.toString());
    });
  };

  const initMap = () => {
    const fallback = { lat: 18.5204, lng: 73.8567 };
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        loadMapWithPosition({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        }),
      () => loadMapWithPosition(fallback),
    );
  };

  // const initAutocomplete = () => {
  //   if (!searchInputRef.current) return;
  //   const autocomplete = new window.google.maps.places.Autocomplete(
  //     searchInputRef.current,
  //   );
  //   autocomplete.bindTo("bounds", mapInstance.current);
  //   autocomplete.addListener("place_changed", () => {
  //     const place = autocomplete.getPlace();
  //     if (!place.geometry?.location) return;
  //     const lat = place.geometry.location.lat();
  //     const lng = place.geometry.location.lng();
  //     mapInstance.current.setCenter({ lat, lng });
  //     mapInstance.current.setZoom(15);
  //     markerRef.current.setPosition({ lat, lng });
  //     setValue("lat", lat.toString());
  //     setValue("long", lng.toString());
  //     searchInputRef.current.value = place.formatted_address;
  //   });
  // };
  const initAutocomplete = () => {
    if (!searchInputRef.current || !mapInstance.current) return; // ✅ FIX

    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInputRef.current,
    );

    autocomplete.bindTo("bounds", mapInstance.current);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.geometry?.location) return;

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      mapInstance.current.setCenter({ lat, lng });
      mapInstance.current.setZoom(15);

      markerRef.current?.setPosition({ lat, lng });

      setValue("lat", lat.toString());
      setValue("long", lng.toString());
      searchInputRef.current.value = place.formatted_address;
    });
  };

  useEffect(() => {
    if (selectedState?.value) {
      dispatch(AllDistrict({ state_id: selectedState.value }));
    } else {
      setValue("district_id", null);
    }
  }, [selectedState, dispatch, setValue]);

  // Timer for Login
  useEffect(() => {
    let interval = null;
    if (isOtpSentLogin && timerLogin > 0) {
      interval = setInterval(() => setTimerLogin((prev) => prev - 1), 1000);
    }
    if (timerLogin === 0 && isOtpSentLogin && !isOtpVerifiedLogin) {
      setIsOtpExpiredLogin(true);
    }
    return () => clearInterval(interval);
  }, [isOtpSentLogin, timerLogin, isOtpVerifiedLogin]);

  // Timer for Register
  useEffect(() => {
    let interval = null;
    if (isOtpSentRegister && timerRegister > 0) {
      interval = setInterval(() => setTimerRegister((prev) => prev - 1), 1000);
    }
    if (timerRegister === 0 && isOtpSentRegister && !isOtpVerifiedRegister) {
      setIsOtpExpiredRegister(true);
    }
    return () => clearInterval(interval);
  }, [isOtpSentRegister, timerRegister, isOtpVerifiedRegister]);

  const formatTimer = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  return (
    <div className="customer-card-container">
      <Form className="customer-form-body" onSubmit={handleSubmit(onSubmit)}>
        {/* Header */}
        <div className="customer-header-row">
          <div className="customer-title-stack">
            <span className="customer-main-title">
              {isRegistering ? "Register as" : "Login as"} {activeTab}
            </span>
            <p className="customer-subtitle">to Nova Prime</p>
          </div>
          <img
            src="/assets/header/nova-prime-logo.png"
            alt="Logo"
            className="customer-brand-logo"
          />
        </div>

        {/* ====================== LOGIN SECTION ====================== */}
        {!isRegistering ? (
          <div className="login-fields-container">
            <div className="customer-input-group">
              <div className="phone-wrapper">
                <span className="country-code">+91</span>
                <Form.Control
                  type="tel"
                  placeholder=" "
                  maxLength={10}
                  disabled={isMobileLockedLogin}
                  {...register("login_mobile", {
                    required: "Mobile number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Enter valid 10 digit mobile number",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                    setMobileOtpErrorLogin("");
                  }}
                  className={classNames("phone-input", {
                    "is-invalid": errors?.login_mobile,
                  })}
                />
              </div>
              <label className="static-label">Mobile Number*</label>
              {errors?.login_mobile && (
                <div className="text-danger mt-1">
                  {errors.login_mobile.message}
                </div>
              )}
            </div>

            {mobileOtpErrorLogin && (
              <div className="text-danger mt-1">{mobileOtpErrorLogin}</div>
            )}

            {isOtpSentLogin && (
              <button
                type="button"
                className="btn btn-link mt-2"
                onClick={() => {
                  setIsOtpSentLogin(false);
                  setIsOtpVerifiedLogin(false);
                  setLoginOtp(["", "", "", "", "", ""]);
                  setTimerLogin(30);
                  setIsOtpExpiredLogin(false);
                  setIsMobileLockedLogin(false);
                  setValue("login_mobile", "");
                }}
              >
                Change Number
              </button>
            )}

            {!isOtpSentLogin && (
              <button
                type="button"
                className="btn btn-outline-primary w-100 mt-2"
                // disabled={!loginMobile || loginMobile.length !== 10}
                disabled={
                  loadingSendLoginOtp ||
                  !loginMobile ||
                  loginMobile.length !== 10
                }
                onClick={handleSendLoginOtp}
              >
                {/* Send OTP */}
                {loadingSendLoginOtp ? "Sending..." : "Send OTP"}
              </button>
            )}

            {isOtpSentLogin && !isOtpVerifiedLogin && (
              <div className="customer-otp-dotted-box">
                {!isOtpExpiredLogin && (
                  <>
                    <label className="customer-otp-label">Enter OTP</label>
                    <div className="customer-otp-slots">
                      {loginOtp.map((digit, index) => (
                        <div key={index} className="customer-otp-slot">
                          <input
                            id={`otp-login-${index}`}
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength="1"
                            value={digit}
                            className="customer-otp-input"
                            onChange={(e) =>
                              handleOtpChange(e.target.value, index, true)
                            }
                            onKeyDown={(e) => handleOtpKeyDown(e, index, true)}
                          />
                          <hr className="customer-otp-line" />
                        </div>
                      ))}
                    </div>
                    {loginOtpError && (
                      <div className="text-danger mt-2">{loginOtpError}</div>
                    )}
                    <button
                      type="button"
                      className="btn btn-success w-100 mt-3"
                      disabled={loadingVerifyLoginOtp}
                      onClick={handleLoginVerifyOtp}
                    >
                      {/* Verify OTP */}
                      {loadingVerifyLoginOtp ? "Verifying..." : "Verify OTP"}
                    </button>
                    <div className="text-center mt-2">
                      <small className="text-muted" key={timerLogin}>
                        Resend OTP in {timerLogin}s
                      </small>
                    </div>
                  </>
                )}

                {isOtpExpiredLogin && (
                  <button
                    type="button"
                    className="btn btn-outline-primary w-100 mt-3"
                    onClick={handleSendLoginOtp}
                  >
                    Resend OTP
                  </button>
                )}
              </div>
            )}

            {/* OTP Verified Message */}
            {isOtpVerifiedLogin && (
              <div className="alert alert-success text-center mt-3">
                OTP Verified Successfully! Click on <strong>Login</strong> to
                continue.
              </div>
            )}
          </div>
        ) : (
          /* ====================== REGISTRATION SECTION ====================== */
          <div className="scroll-form-body">
            <div className="register-fields-container">
              {/* Name */}
              <div className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  {...register("name", {
                    required: "Full Name is required",
                    pattern: {
                      value: /^[A-Za-z\s]+$/,
                      message: "Name cannot contain numbers",
                    },
                  })}
                  className={classNames({ "is-invalid": errors?.name })}
                />
                <label>Full Name*</label>
                {errors?.name && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.name.message}
                  </span>
                )}
              </div>

              {/* Mobile Number */}
              <div className="customer-input-group">
                <div className="phone-wrapper">
                  <span className="country-code">+91</span>
                  <Form.Control
                    type="tel"
                    placeholder=" "
                    maxLength={10}
                    disabled={isOtpSentRegister || isMobileLockedRegister}
                    {...register("mobile_number", {
                      required: "Mobile number is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Enter valid 10 digit mobile number",
                      },
                    })}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10);
                      setMobileOtpErrorRegister("");
                    }}
                    className={classNames("phone-input", {
                      "is-invalid": errors?.mobile_number,
                    })}
                  />
                </div>
                <label className="static-label">Mobile Number*</label>
                {errors?.mobile_number && (
                  <span className="invalid-feedback d-block mb-2">
                    {errors.mobile_number.message}
                  </span>
                )}
              </div>

              {isOtpSentRegister && (
                <button
                  type="button"
                  className="btn btn-link p-0 mt-1"
                  onClick={() => {
                    setIsOtpSentRegister(false);
                    setIsOtpVerifiedRegister(false);
                    setRegisterOtp(["", "", "", "", "", ""]);
                    setTimerRegister(60);
                    setIsOtpExpiredRegister(false);
                    setIsMobileLockedRegister(false);
                    setRegisterOtpError("");
                    setMobileOtpErrorRegister("");
                    setValue("mobile_number", "");
                  }}
                >
                  Change Number
                </button>
              )}

              {!isOtpSentRegister && !isOtpVerifiedRegister && (
                <button
                  type="button"
                  className="btn btn-outline-primary w-100 mt-2"
                  // disabled={!registerMobile || registerMobile.length !== 10}
                  disabled={
                    loadingSendRegisterOtp ||
                    !registerMobile ||
                    registerMobile.length !== 10
                  }
                  onClick={handleSendRegisterOtp}
                >
                  {/* Send OTP */}
                  {loadingSendRegisterOtp ? "Sending..." : "Send OTP"}
                </button>
              )}

              {mobileOtpErrorRegister && (
                <div className="text-danger mt-2">{mobileOtpErrorRegister}</div>
              )}

              {isOtpSentRegister &&
                !isOtpExpiredRegister &&
                !isOtpVerifiedRegister && (
                  <div className="customer-otp-dotted-box">
                    <label className="customer-otp-label">Enter OTP</label>
                    <div className="customer-otp-slots">
                      {registerOtp.map((digit, index) => (
                        <div key={index} className="customer-otp-slot">
                          <input
                            id={`otp-register-${index}`}
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength="1"
                            value={digit}
                            className="customer-otp-input"
                            onChange={(e) =>
                              handleOtpChange(e.target.value, index, false)
                            }
                            onKeyDown={(e) => handleOtpKeyDown(e, index, false)}
                          />
                          <hr className="customer-otp-line" />
                        </div>
                      ))}
                    </div>
                    {registerOtpError && (
                      <div className="text-danger mt-1">{registerOtpError}</div>
                    )}
                    <button
                      type="button"
                      className="btn btn-success w-100 mt-3"
                      disabled={loadingVerifyRegisterOtp}
                      onClick={handleVerifyRegisterOtp}
                    >
                      {/* Verify OTP */}
                      {loadingVerifyRegisterOtp ? "Verifying..." : "Verify OTP"}
                    </button>
                    <div className="text-center mt-2">
                      <small className="text-muted">
                        Resend OTP in {timerRegister}s
                      </small>
                    </div>
                  </div>
                )}

              {isOtpSentRegister &&
                isOtpExpiredRegister &&
                !isOtpVerifiedRegister && (
                  <button
                    type="button"
                    className="btn btn-outline-primary w-100 mt-2"
                    onClick={handleSendRegisterOtp}
                  >
                    Resend OTP
                  </button>
                )}

              {/* OTP Verified - Same as Vendor */}
              {isOtpVerifiedRegister && (
                <div className="customer-otp-dotted-box text-center">
                  <button
                    type="button"
                    className="btn btn-success w-100 mt-3"
                    disabled
                  >
                    OTP Verified ✅
                  </button>
                </div>
              )}

              {/* All other registration fields (Whatsapp, Profile Pic, State, District, Aadhar, Profession, Experience, DOB, Map) */}
              {/* <div className="customer-input-group">
                <div className="phone-wrapper">
                  <span className="country-code">+91</span>
                  <Form.Control
                    type="tel"
                    placeholder=" "
                    maxLength={10}
                    {...register("whatsapp_no", {
                      required: "Whatsapp number is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Enter valid 10 digit Whatsapp number",
                      },
                    })}
                    onInput={(e) =>
                      (e.target.value = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10))
                    }
                    className={classNames("phone-input", {
                      "is-invalid": errors?.whatsapp_no,
                    })}
                  />
                </div>
                <Form.Label className="static-label">
                  Whatsapp Mobile Number*
                </Form.Label>
                {errors?.whatsapp_no && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.whatsapp_no.message}
                  </span>
                )}
              </div> */}

              {/* Aadhar */}
              <div className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  maxLength={12}
                  {...register("adhar_no", {
                    required: "Aadhar Card Number is required",
                    pattern: {
                      value: /^[0-9]{12}$/,
                      message: "Enter valid 12 digit Aadhar",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 12);
                    // Cookies.remove("aadhaar_ref_id");

                    // setAadharOtpError("");
                  }}
                  className={classNames({ "is-invalid": errors?.adhar_no })}
                  // disabled={isAadharOtpVerified}
                  disabled={isAadharLocked}
                />

                <label>Aadhar Number*</label>

                {errors?.adhar_no && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.adhar_no.message}
                  </span>
                )}
              </div>

              {isAadharOtpSent && !isAadharOtpVerified && (
                <button
                  type="button"
                  className="btn btn-link p-0 mt-1"
                  onClick={() => {
                    setIsAadharLocked(false);

                    setValue("adhar_no", "");

                    setIsAadharOtpSent(false);
                    setIsAadharOtpVerified(false);

                    setAadharOtp(["", "", "", "", "", ""]);

                    // setAadharOtpTimer(120);
                    setAadharOtpTimer(600);

                    setIsAadharOtpExpired(false);

                    setAadharOtpError("");

                    Cookies.remove("aadhaar_ref_id");
                  }}
                >
                  Change Aadhaar Number
                </button>
              )}

              {/* Send OTP Button */}
              {!isAadharOtpSent && !isAadharOtpVerified && (
                <button
                  type="button"
                  className="btn btn-outline-primary w-100 mt-2"
                  onClick={handleSendAadharOtp}
                  disabled={loadingAadharSendOtp}
                >
                  {loadingAadharSendOtp ? "Sending..." : "Send Aadhaar OTP"}
                </button>
              )}

              {/* Aadhaar Error Message */}
              {aadharOtpError && !isAadharOtpSent && (
                <div className="text-danger mt-2 text-center">
                  {aadharOtpError}
                </div>
              )}

              {/* OTP Box */}
              {isAadharOtpSent && !isAadharOtpVerified && (
                <div className="customer-otp-dotted-box">
                  <label className="customer-otp-label">
                    Enter Aadhaar OTP
                  </label>

                  <div className="customer-otp-slots">
                    {aadharOtp.map((digit, index) => (
                      <div key={index} className="customer-otp-slot">
                        <input
                          id={`otp-aadhar-${index}`}
                          type="tel"
                          inputMode="numeric"
                          maxLength="1"
                          value={digit}
                          className="customer-otp-input"
                          onChange={(e) =>
                            handleAadharOtpChange(e.target.value, index)
                          }
                          onKeyDown={(e) => handleAadharOtpKeyDown(e, index)}
                        />
                        <hr className="customer-otp-line" />
                      </div>
                    ))}
                  </div>

                  {aadharOtpError && (
                    <div className="text-danger text-center mt-2">
                      {aadharOtpError}
                    </div>
                  )}

                  <button
                    type="button"
                    className="btn btn-success w-100 mt-3"
                    onClick={handleVerifyAadharOtp}
                    disabled={loadingAadharVerifyOtp}
                  >
                    {loadingAadharVerifyOtp
                      ? "Verifying..."
                      : "Verify Aadhaar OTP"}
                  </button>

                  {!isAadharOtpExpired ? (
                    <div className="text-center mt-2">
                      <small className="text-muted">
                        Resend Aadhaar OTP in {formatTimer(aadharOtpTimer)}
                      </small>
                    </div>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-link w-100 mt-2"
                      onClick={async () => {
                        Cookies.remove("aadhaar_ref_id"); // remove old req_id

                        setAadharOtp(["", "", "", "", "", ""]);
                        setAadharOtpError("");
                        setIsAadharOtpExpired(false);
                        // setAadharOtpTimer(120);
                        setAadharOtpTimer(600);

                        await handleSendAadharOtp(); // sends OTP and stores new req_id
                      }}
                    >
                      Resend Aadhaar OTP
                    </button>
                  )}
                </div>
              )}

              {/* Verified Message */}
              {isAadharOtpVerified && (
                <div className="customer-otp-dotted-box text-center">
                  <button
                    type="button"
                    className="btn btn-success w-100"
                    disabled
                  >
                    Aadhaar OTP Verified ✅
                  </button>
                </div>
              )}

              <div className="customer-input-group">
                <Form.Control
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  {...register("profile_pic", {
                    required: "Profile picture is required",
                    validate: (value) => {
                      if (!value?.[0]) return true;
                      const allowed = ["image/jpeg", "image/png", "image/jpg"];
                      return (
                        allowed.includes(value[0].type) ||
                        "Only JPG, JPEG, PNG files are allowed"
                      );
                    },
                  })}
                  className={classNames({ "is-invalid": errors?.profile_pic })}
                />
                {profilePicFile?.length > 0 && (
                  <div className="mt-2">
                    <img
                      src={URL.createObjectURL(profilePicFile[0])}
                      alt="Profile Preview"
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "cover",
                        borderRadius: "50%",
                        border: "2px solid #ddd",
                      }}
                    />
                  </div>
                )}
                <label className="static-label">Profile Photo*</label>
                {errors?.profile_pic && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.profile_pic.message}
                  </span>
                )}
              </div>

              {/* State */}
              <div className="customer-input-group">
                <Controller
                  name="state_id"
                  control={control}
                  rules={{ validate: (v) => v || "State is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={states}
                      styles={selectStyles}
                      placeholder=""
                      onChange={(val) => {
                        field.onChange(val);
                        setValue("district_id", null);
                        dispatch(AllDistrict({ state_id: val?.value }));
                      }}
                    />
                  )}
                />
                <label className="floating-label">State*</label>
                {errors?.state_id && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.state_id.message}
                  </span>
                )}
              </div>

              {/* District */}
              <div className="customer-input-group">
                <Controller
                  name="district_id"
                  control={control}
                  rules={{
                    validate: (v) =>
                      !selectedState ? true : v || "City is required",
                  }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={districts}
                      styles={selectStyles}
                      placeholder=""
                      isDisabled={!selectedState}
                    />
                  )}
                />
                <label className="floating-label">City*</label>
                {errors?.district_id && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.district_id.message}
                  </span>
                )}
              </div>

              {/* Profession */}
              <div className="customer-input-group">
                <Controller
                  name="profession_id"
                  control={control}
                  rules={{
                    required: "Profession is required",
                    validate: (value) =>
                      value?.length <= 3 ||
                      "You can select maximum 3 professions",
                  }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isMulti
                      options={professions}
                      styles={catSelectStyles}
                      placeholder=""
                      value={field.value || []}
                      onChange={(selectedOptions) => {
                        if (selectedOptions.length <= 3) {
                          field.onChange(selectedOptions);
                        }
                        if (selectedOptions.length > 3) {
                          alert("You can select only 3 professions");
                          return;
                        }
                      }}
                    />
                  )}
                />
                <label className="floating-label">Profession*</label>
                {errors?.profession_id && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.profession_id.message}
                  </span>
                )}
              </div>

              <div className="customer-input-group">
                <Controller
                  name="sub_profession_id"
                  control={control}
                  rules={{
                    required: "Sub Profession is required",
                    validate: (value) =>
                      value?.length <= 3 ||
                      "You can select maximum 3 sub professions",
                  }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isMulti
                      options={all_sub_profession}
                      styles={catSelectStyles}
                      placeholder=""
                      value={field.value || []}
                      isDisabled={!selectedProfession?.length}
                      onChange={(selectedOptions) => {
                        if ((selectedOptions || []).length <= 3) {
                          field.onChange(selectedOptions);
                        } else {
                          alert("You can select only 3 sub professions");
                        }
                      }}
                    />
                  )}
                />
                <label className="floating-label">Sub Profession*</label>
                {errors?.sub_profession_id && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.sub_profession_id.message}
                  </span>
                )}
              </div>

              {/* DOB */}
              <div className="customer-input-group">
                <Form.Control
                  type="date"
                  max={new Date().toISOString().split("T")[0]}
                  {...register("dob", {
                    required: "Date of Birth is required",
                    validate: (v) =>
                      new Date(v) <= new Date() ||
                      "Date of Birth cannot be in the future",
                  })}
                  className={classNames({ "is-invalid": errors?.dob })}
                />
                <label className="floating-label">DOB*</label>
                {errors?.dob && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.dob.message}
                  </span>
                )}
              </div>

              {/* Experience */}
              <div className="customer-input-group">
                {/* <Form.Control
                  type="number"
                  placeholder=" "
                  {...register("experience", {
                    required: "Experience is required",
                    min: { value: 0, message: "Experience cannot be negative" },
                    max: {
                      value: 50,
                      message: "Experience cannot exceed 50 years",
                    },
                  })}
                  className={classNames({ "is-invalid": errors?.experience })}
                /> */}
                <Form.Control
                  type="number"
                  placeholder=" "
                  {...register("experience", {
                    required: "Experience is required",
                    min: { value: 0, message: "Experience cannot be negative" },
                    max: {
                      value: 50,
                      message: "Experience cannot exceed 50 years",
                    },
                    validate: (value) => {
                      const dob = getValues("dob");

                      if (!dob) return "Please select Date of Birth first";

                      const birthYear = new Date(dob).getFullYear();
                      const currentYear = new Date().getFullYear();

                      const maxExperience = currentYear - birthYear;

                      if (value > maxExperience) {
                        return `Invalid experience. Maximum allowed is ${maxExperience} years`;
                      }

                      return true;
                    },
                  })}
                  className={classNames({ "is-invalid": errors?.experience })}
                />
                <label className="floating-label">Experience (Years)*</label>
                {errors?.experience && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.experience.message}
                  </span>
                )}
              </div>

              {/* Map */}
              <Form.Group className="customer-input-group">
                <Form.Control {...register("lat")} readOnly />
                <label className="static-label">Latitude</label>
              </Form.Group>

              <Form.Group className="customer-input-group">
                <Form.Control {...register("long")} readOnly />
                <label className="static-label">Longitude</label>
              </Form.Group>

              <Form.Group className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  ref={searchInputRef}
                />
                <Form.Label className="static-label">
                  Search Location
                </Form.Label>
              </Form.Group>

              <div
                ref={mapRef}
                style={{
                  width: "100%",
                  height: "300px",
                  borderRadius: "10px",
                  marginTop: "10px",
                }}
              />
            </div>
          </div>
        )}

        {/* Footer */}
        <div className="customer-footer-actions">
          <div className="footer-content-block">
            {/* <Common_Login_Button
                text={isRegistering ? "Register" : "Login"}
                disabled={isRegistering && !isOtpVerifiedRegister}
              /> */}
            <Common_Login_Button
              text={
                loadingSubmit
                  ? "Processing..."
                  : isRegistering
                  ? "Register"
                  : "Login"
              }
              disabled={
                loadingSubmit || (isRegistering && !isOtpVerifiedRegister)
              }
            />
            <div className="customer-toggle-footer">
              <span className="acc-text">
                {isRegistering
                  ? "You have an account?"
                  : "Don't have an account?"}
              </span>
              <button
                type="button"
                className="customer-toggle-link"
                onClick={() => {
                  setIsRegistering(!isRegistering);
                  // 🧹 RESET MAP REFS
                  mapInstance.current = null;
                  markerRef.current = null;

                  if (isRegistering) {
                    setRegisterOtp(["", "", "", "", "", ""]);
                    setIsOtpSentRegister(false);
                    setIsOtpVerifiedRegister(false);
                    setIsOtpExpiredRegister(false);
                  } else {
                    setLoginOtp(["", "", "", "", "", ""]);
                    setIsOtpSentLogin(false);
                    setIsOtpVerifiedLogin(false);
                    setIsOtpExpiredLogin(false);
                  }
                }}
              >
                {isRegistering ? "Login Now" : "Create Account"}
              </button>
            </div>
          </div>
        </div>
      </Form>

      <Account_Created_Modal
        showAccountModal={showAccountModal}
        handleAccountModalClose={() => setShowAccountModal(false)}
        text={modalText}
      />
    </div>
  );
};

export default Expert_Login;
